import React, {useEffect, useState} from 'react';
import {Box, CardContent, Grid, Typography} from '@deere/fuel-react';
import {getCategoryTotal, getCategoryWeightTotal, getTotalSelected} from "../shared/utils";
import {useStyles} from "../shared/styles/Ratings";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {RatingPgmPublishSubCatCard} from "./RatingPgmPublishSubCatCard";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {RatingPgmPublishSubCatCardDetails} from "./RatingPgmPublishSubCatCardDetails";

export const RatingProgramPublish = ({currentData, onSelectStep}) => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState('panel1');
    const [subCatExpanded, setSubCatExpanded] = useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleSubCatChange = (panel) => (event, newExpanded) => {
        setSubCatExpanded(newExpanded ? panel : false);
    };

    const filterCriteria = (subCategoryId) => {
        return currentData.criteria.filter(item => {
            return item.isSelected && item.subCategory["id"] === subCategoryId
        })
    }

    useEffect(() => {
            onSelectStep(3);
        },// eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    return (
        <Grid container alignItems="center">
            <Grid item xs={12}>
                <Box mt={2} mr={6} mb={2}>
                    {currentData.category.map((item, index) => {
                        return (
                            <CardContent style={{padding: 0, marginTop: 5}} key={index}>
                                <div className={classes.root}>
                                    <Accordion expanded={expanded === `panel${item.id}`}
                                               onChange={handleChange(`panel${item.id}`)}>
                                        <AccordionSummary
                                            className={classes.accordionSummary}
                                            classes={{
                                                expandIcon: classes.expandIcon,
                                                content: classes.content,
                                                expanded: classes.expanded
                                            }}
                                            expandIcon={<ExpandMoreIcon
                                                style={{fontSize: '2rem'}}/>}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                        >
                                            <Grid container alignItems="center">
                                                <Grid item xs={10}>
                                                    <Box ml={3} mr={3} mb={3} mt={1}>
                                                        <Typography variant="h3">
                                                            {item.description}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Box ml={3} mr={3} mb={3} mt={1}>
                                                        <Typography variant="h3">
                                                            {getCategoryTotal(currentData, item.id)}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Box ml={3} mr={3} mb={3} mt={1}>
                                                        <Typography variant="h3">
                                                            {`${getCategoryWeightTotal(currentData, item.id)}%`}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.accordionDetails}>
                                            <Grid container>
                                                {item.subCategories.map((subcat, index) => {
                                                    const selectedCriteria = filterCriteria(subcat.id)
                                                    const totalSelected = getTotalSelected(currentData, subcat.id)
                                                    return (
                                                        <Grid item xs={12} key={index}>
                                                            <CardContent
                                                                style={{padding: 0, marginTop: 10}}>
                                                                <div className={classes.root}>
                                                                    <Accordion
                                                                        expanded={subCatExpanded === `${subcat.id}`}
                                                                        onChange={handleSubCatChange(`${subcat.id}`)}
                                                                        disabled={totalSelected === 0} classes={{disabled: classes.bgDisabled}}>
                                                                        <RatingPgmPublishSubCatCard
                                                                            subCategory={subcat}
                                                                            totalSelected={totalSelected}
                                                                            selectedCriteria={selectedCriteria}
                                                                            expanded={subCatExpanded}/>
                                                                        <RatingPgmPublishSubCatCardDetails
                                                                            selectedCriteria={selectedCriteria}/>
                                                                    </Accordion>
                                                                </div>
                                                            </CardContent>
                                                        </Grid>
                                                    )
                                                })}
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                            </CardContent>
                        )
                    })}
                </Box>
            </Grid>
        </Grid>
    );
};
